import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BenchlingState} from 'redux-stores/reduceApp';
import APIUtil from 'util/APIUtil';
import memoizeLastCall from 'util/memoizeLastCall';
import {WorkflowSelector, WorkflowsState} from 'workflows/reduceWorkflows';
import {
  STAGE_RUN_FULL_SHAPE,
  STAGE_RUN_SAMPLE_FULL_SHAPE,
  StageRun,
  StageRunSample,
} from 'workflows/WorkflowConstants';

/**
 * DEPRECATED:
 * Gets stage runs and stage run samples for a stage entry from the Redux store and passes them as props to
 * a wrapped component.
 * This component was written before we had Redux, and child components should now be directly connecting
 * to the store.
 */

function makeMapStateToProps(): (state: BenchlingState, props: {entryId: string}) => ConnectedProps {
  const mapSubStateToProps = memoizeLastCall((entryId: string, workflowsReduxState: WorkflowsState) => {
    if (APIUtil.apiIdToType(entryId) !== ModelTypeConstants.STAGE_ENTRY) {
      return {
        stageRuns: [],
        stageRunSampleById: {},
      };
    }
    const workflowSelector = new WorkflowSelector(workflowsReduxState);
    return {
      stageRuns: workflowSelector.getOrderedStageRunsForEntry(entryId),
      stageRunSampleById: workflowSelector.getStageRunSampleById(),
    };
  });
  const mapStateToProps = (
    state: BenchlingState,
    props: {entryId: string}
  ): {
    stageRunSampleById: Record<string, StageRunSample>;
    stageRuns: Array<StageRun>;
  } => mapSubStateToProps(props.entryId, state.models.workflows);
  return mapStateToProps;
}

interface ConnectedProps {
  stageRuns: Array<StageRun>;
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample};
}

interface GetStageRunsWrapperProps extends ConnectedProps {
  children: (
    stageRuns: Array<StageRun>,
    stageRunSampleById: {[stageRunSampleId: string]: StageRunSample}
  ) => JSX.Element;
  entryId: string;
}

class GetStageRunsWrapper extends React.Component<GetStageRunsWrapperProps> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    children: PropTypes.func.isRequired,
    entryId: PropTypes.string.isRequired,

    // Provided by connect
    stageRuns: PropTypes.arrayOf(STAGE_RUN_FULL_SHAPE.isRequired).isRequired,
    stageRunSampleById: PropTypes.objectOf(STAGE_RUN_SAMPLE_FULL_SHAPE).isRequired,
  };

  render(): JSX.Element {
    return this.props.children(this.props.stageRuns, this.props.stageRunSampleById);
  }
}

export default connect(makeMapStateToProps)(GetStageRunsWrapper);
